export default "ORI - Gestion de Temple d'Umbanda";
